export default __webpack_public_path__ + "static/media/squares500.aa5bc17e.jpg";